module.exports = __webpack_public_path__ + "media/images/nurture_growth_icon-dfcbd6973e07a5623e50e207f31ac14c.png";